module.exports = __webpack_public_path__ + "img/nav_8.3487ceb1.png";